import { CalendarMode } from "PFApp/booking/types";
import useStorage from "PFCore/helpers/use_storage";

export const useCalendarMode = () => useStorage<CalendarMode>("overview_bookings_tab", CalendarMode.Projects);
